import React from 'react';

const NewAddressNotification = () => {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="36" height="36" rx="18" fill="#FFE9E9" />
      <mask
        id="mask0_1006_3571"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="8"
        width="20"
        height="20"
      >
        <rect x="8" y="8" width="20" height="20" fill="#EC5962" />
      </mask>
      <g mask="url(#mask0_1006_3571)">
        <path
          d="M23.0007 25.5002C21.8479 25.5002 20.8654 25.0941 20.0532 24.2818C19.2404 23.4691 18.834 22.4863 18.834 21.3335C18.834 20.1807 19.2404 19.1979 20.0532 18.3852C20.8654 17.5729 21.8479 17.1668 23.0007 17.1668C24.1534 17.1668 25.1362 17.5729 25.949 18.3852C26.7612 19.1979 27.1673 20.1807 27.1673 21.3335C27.1673 22.4863 26.7612 23.4691 25.949 24.2818C25.1362 25.0941 24.1534 25.5002 23.0007 25.5002ZM22.584 23.8335H23.4173V21.7502H25.5007V20.9168H23.4173V18.8335H22.584V20.9168H20.5007V21.7502H22.584V23.8335ZM11.334 23.8335V13.8335L18.0007 8.8335L24.6673 13.8335V15.7502C24.4034 15.6668 24.1326 15.6043 23.8548 15.5627C23.577 15.521 23.2923 15.5002 23.0007 15.5002C21.3895 15.5002 20.0145 16.0696 18.8757 17.2085C17.7368 18.3474 17.1673 19.7224 17.1673 21.3335C17.1673 21.7641 17.2126 22.1913 17.3032 22.6152C17.3932 23.0385 17.5354 23.4446 17.7298 23.8335H11.334Z"
          fill="#EC5962"
        />
      </g>
    </svg>
  );
};

export default NewAddressNotification;
